import { array, option } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { useMemo } from 'react';
import { match } from 'ts-pattern';

import { MessageType } from '../../domain';

const getFirstTypeName = (types: MessageType[]) =>
  pipe(
    types,
    array.head, // get the first message type if it exists
    option.map((t) => t.name),
    option.getOrElse(() => 'Unknown Message Type'), // fallback to default text
  );

export const useMessageTypeOrTypes = (selectedTypes: MessageType[]): string =>
  useMemo(
    () =>
      match(selectedTypes)
        .when((c) => c.length === 1, getFirstTypeName)
        .otherwise((c) => `${c.length} message types`),
    [selectedTypes],
  );
